import * as React from 'react';

interface BtnActionValidationBatProps {
  validationBat: any,
  isInternalUser: boolean,
  customerView: boolean,
  needOperator: boolean,
  disabled: boolean,
  statut: number,
  dataConformity: {etatConformity: number | null, logsConformity: string | null}
  fichiersConfirmes: boolean;
}

export const BtnActionValidationBat = (props: BtnActionValidationBatProps) => {

  let strTitle = props.isInternalUser && !props.customerView && (props.statut === 1 || props.statut === null) ? 'Je valide mes modifications en tant qu\'opérateur fichier' : props.isInternalUser && !props.customerView ? 'Je valide ce fichier en tant qu\'opérateur' :  'Valider le BAT';

  strTitle = (props.statut > 0 && props.statut < 4) ? 'Annuler mon choix ' : strTitle;

  function _validateBat(event: any) {
    if(props.statut > 0 && props.statut < 4) {
      props.validationBat(true);
    } else if(!props.needOperator || (props.isInternalUser && props.dataConformity.etatConformity)) {
      props.validationBat(false);
    }
  }

  let disabled = (props.disabled || props.needOperator ||  (props.isInternalUser && props.statut === 2) && props.fichiersConfirmes);

  if(props.dataConformity.etatConformity !== null && props.isInternalUser) {
    disabled = false;
  }

  if(props.needOperator && props.statut === 1 && !props.fichiersConfirmes) {
    disabled = false;
  }

  return (
      <button disabled={disabled} id={"validationBat"} className={`btnBatAuto cursor-pointer bold text-center py-4 px-4 w-100 ${disabled ? 'grey cursor-notAllowed opacDisabled ' : ' btnBatAutoBat '}`}  onClick={(e) => {_validateBat(e)}} >
            <span className={'bold'}>
               {strTitle}
            </span>
      </button>
  );
}